import * as React from "react"

// Lazy-load the heavy globe code only when the section scrolls into view.
// Renders a placeholder of the same height so the panel slot doesn't shift
// when the globe arrives.
const ReaderMapPanel = React.lazy(() => import("./ReaderMapPanel"))

const ReaderMapSection: React.FC = () => {
  const ref = React.useRef<HTMLDivElement | null>(null)
  const [shouldRender, setShouldRender] = React.useState(false)

  React.useEffect(() => {
    if (!ref.current) return
    if (typeof IntersectionObserver === "undefined") {
      setShouldRender(true)
      return
    }
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setShouldRender(true)
          io.disconnect()
        }
      },
      { rootMargin: "200px" }
    )
    io.observe(ref.current)
    return () => io.disconnect()
  }, [])

  return (
    <div ref={ref}>
      <React.Suspense fallback={<ReaderMapPlaceholder />}>
        {shouldRender ? <ReaderMapPanel /> : <ReaderMapPlaceholder />}
      </React.Suspense>
    </div>
  )
}

const ReaderMapPlaceholder: React.FC = () => (
  <div
    className="bg-primary/30 border border-secondary/30 rounded-lg"
    style={{ minHeight: 460 }}
    aria-hidden
  />
)

export default ReaderMapSection
